export const roundFloatTo = (number: number, digitsAfterDecimal: number) => {
  const tenishNumberForCalculations = 10 ** digitsAfterDecimal
  return Number(
    (
      Math.floor(number * tenishNumberForCalculations) /
      tenishNumberForCalculations
    ).toFixed(digitsAfterDecimal),
  )
}
